import actions from '../../actionTypes';

export default (area) => {
  return {
    type: actions.ADD_AREA,
    area
  };
};



// WEBPACK FOOTER //
// ./src/reducers/areas/actions/areaAdd.js